import React, { useContext } from 'react'

import RenderContext from './RenderContext'

import {
  ILayout_Render,
  ILayout_Cell_Props_Text,
} from '../types/layout'

import HTML from '../texteditor/HTML'

/*

  RENDER

*/
const TextComponent: ILayout_Render<ILayout_Cell_Props_Text> = ({
  cell,
}) => {
  const {
    preview,
    values,
  } = useContext(RenderContext)
  return (
    <HTML
      value={ cell.data.text }
      preview={ preview }
      values={ values }
    />
  )
}

export default TextComponent
